<script setup lang="ts">
import {
  YoutubeIcon,
  InstagramIcon,
  TwitterIcon,
  FacebookIcon,
} from '~/components/design-system/icons';
import type { socialIcons } from '~/interfaces/components/icons';

interface Props {
  type?: 'text' | 'social-icon' | 'dialing-code';
  disabled?: boolean;
  icon?: socialIcons;
}

const props = withDefaults(defineProps<Props>(), {
  type: 'text',
  disabled: false,
  icon: 'instagram',
});

const siteStore = useSiteStore();

const icons: Record<socialIcons, Component> = {
  instagram: InstagramIcon,
  youtube: YoutubeIcon,
  twitter: TwitterIcon,
  x: TwitterIcon,
  facebook: FacebookIcon,
};

const returnIcon = computed(() => {
  return icons[props.icon];
});
</script>

<template>
  <span
    class="absolute text-base-priority left-0 top-0 border-r p-3 rounded-l-lg stacked-border-color"
    :class="{
      '!text-dark-800/30 dark:!text-light-700/40': disabled,
    }"
  >
    <slot v-if="type === 'text'" />
    <span v-else-if="type === 'dialing-code'">
      {{ siteStore.getDialingCode }}
    </span>
    <component :is="returnIcon" v-else :key="icon" class="!w-6" />
  </span>
</template>

<style scoped lang="scss"></style>
